<template>
    <v-card :class="{'pa-3': $vuetify.breakpoint.xs, 'pa-5': $vuetify.breakpoint.smAndUp}" :width="$vuetify.breakpoint.mdAndUp ? 1100 : 'auto'">
        <v-form @submit.prevent>
            <v-icon class="modal-close" @click.native="CLOSE_MODAL('modal_comment_edit')">{{$t("закрыть")}}</v-icon>
            <v-card-title class="display-1 mb-4">{{$t("Редактировать комментарий")}}</v-card-title>
            <v-layout mb-4>
                <v-flex xs12>
                    <div class="grey-text mb-2">{{$t("Введите текст")}}</div>
                    <textareaBase v-model='textArea' :placeholder="$t('Введите текст')" rows="4" :value="textArea" />
                </v-flex>
            </v-layout>
            <v-card-actions>
                <v-layout align-center wrap>
                    <buttonRed :class="{'flex xs12 mr-0 mb-2': $vuetify.breakpoint.xs, 'mr-4': $vuetify.breakpoint.smAndUp}" @click.native="edit_event_comment(textArea)">{{$t("Отправить")}}</buttonRed>
                    <buttonBdWhite :class="{'flex xs12 mr-0 mb-2': $vuetify.breakpoint.xs, 'mr-4': $vuetify.breakpoint.smAndUp}" @click.native="delete_event_comment({comment_id: edited_comment_id, reason: ''})">{{$t("Удалить")}}</buttonBdWhite>
                </v-layout>
            </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>
import buttonRed   from '@/components/ui/buttons/button_red';
import textareaBase from '@/components/ui/inputs/base/textarea';
import inputBase from '@/components/ui/inputs/base/input';
import buttonBdWhite from '@/components/ui/buttons/button_bd_white';
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  components: {
    buttonRed,
    textareaBase,
    inputBase,
    buttonBdWhite,
  },
  computed: {
    ...mapGetters('news_main/detail', [
      'edited_comment_id',
      'current_edited_comment',
    ]),
    textArea: {
      get() {
        return this.current_edited_comment ? this.current_edited_comment.text : '';
      },
      set($event) {
        return this.EDIT_COMMENT_TEXT({id: this.edited_comment_id, value: $event.target.value});
      },
    },
  },
  methods: {
    ...mapMutations('news_main/detail', [
      'EDIT_COMMENT_TEXT',
      'CLOSE_MODAL',
    ]),
    ...mapActions('news_main/detail', [
      'edit_event_comment',
      'delete_event_comment',
    ]),

  },


};
</script>
